import { Component } from '@angular/core';
import { ResourceListComponent } from '../../shared/resource-list/resource-list.component';

@Component({
  selector: 'app-hr',
  standalone: true,
  imports: [ResourceListComponent],
  template: `<app-resource-list title="HR" apiPath="v1/Employees" />`
})
export class HrComponent {}
